import React from 'react'
import styles from './Body.module.css'
import {
    ViewPager,
    Frame,
    Track,
    View,
} from 'react-view-pager'

import {
    STAGES_INFO,
} from '../../../../util/values'


const Body = ({
    stages,
    onViewChange,
    viewPagerElement,
    scores,
    onStageClick,
    stageIndex,
}) => {
    let lastOpen = 0;
    let count = 0;
    for (let stageIndex of stages) {
        if (scores && scores[String(stageIndex)] !== undefined) {
            lastOpen = count;
        }
        count++;
    }
    lastOpen += 1;
    if (lastOpen === 1 && (!scores || scores[String(stages[0])] === undefined)) {
        lastOpen--;
    }

    return (
        <ViewPager
            className={styles.viewPager}>
            <Frame
                className={styles.frame}>
                <Track
                    ref={c => viewPagerElement.current = c}
                    viewsToShow={1}
                    infinite={false}
                    onViewChange={(index) => onViewChange(index)}
                    className={styles.track}
                >
                    {
                        stages.map((stageIndex, index) => {
                            const stageScore = scores ? scores[String(stageIndex)] : undefined;
                            let done = false;
                            let noScore = false;
                            if (stageScore === undefined) {
                                noScore = true;
                            }
                            else {
                                done = true;
                                if (Number(stageScore) === -1) noScore = true;
                            }
                            return (
                                <View
                                    className={styles.view}
                                    key={String(stageIndex)}>
                                    <div
                                        className={styles.container}>
                                        {noScore ? <div className={styles.noScore} /> : <p
                                            className={styles.score}
                                            style={{
                                                color:
                                                    stageScore === 10 ?
                                                        '#26C281' :
                                                        stageScore >= 6 ?
                                                            '#309CFF' : '#FF6464'
                                            }}>
                                            {parseFloat(scores[String(stageIndex)]).toFixed(1)}
                                        </p>}
                                        <div
                                            onClick={() => onStageClick(stageIndex, index)}
                                            className={index <= lastOpen ? styles.circle : styles.circleLocked}
                                            style={done ? { backgroundColor: '#FEE79B' } : {}}>
                                            {done ? STAGES_INFO[stageIndex - 1].iconDone : STAGES_INFO[stageIndex - 1].icon}
                                        </div>
                                        <p className={styles.exercise} style={{opacity: index <= lastOpen ? 1 : 0.3}}>
                                            {STAGES_INFO[stageIndex - 1].name}
                                        </p>
                                    </div>
                                </View>
                            )
                        })
                    }
                </Track>
            </Frame>
        </ViewPager>
    )
}

export default Body
